import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import LinkIcon from '@mui/icons-material/Link';
import DoneIcon from '@mui/icons-material/Done';

import classes from './Activities.module.css';

const Activities = props => {
  const url = window.location.pathname.split('/');
  const { t } = useTranslation(['lesson']);

  const changeViewHandler = newValue => {
    props.changeView(newValue);
    let section = '';
    if (newValue === 1) {
      if (props.format === 'AUDIO') {
        section = 'aud';
      } else {
        section = 'f';
      }
    } else if (newValue === 2) {
      section = 'q';
    } else if (newValue === 3) {
      section = 'ac';
    } else {
      section = 'coe';
    }

    if (url[2] === 'a' || url[2] === 'course') {
      history.replaceState(
        null,
        null,
        `/${url[1]}/${url[2]}/${section}/${url[4]}/${url[5]}`
      );
    } else {
      history.replaceState(
        null,
        null,
        `/${url[1]}/${section}/${url[3]}/${url[4]}`
      );
    }
    props.changeView(newValue);
  };

  return (
    <div>
      <p className={classes.text}>{t('activities_to_finish')}</p>
      {props.lessonProgress.map(progress => (
        <>
          {progress.eventType === 1 && (
            <Button
              onClick={() => changeViewHandler(1)}
              className={classes.activityBtn}
            >
              <DoneIcon
                className={`${classes.doneIcon} ${
                  progress.mediaStatus === 2 && classes.success
                } ${
                  (progress.mediaStatus === 1 ||
                    props.videoProgress) &&
                  classes.progress
                }`}
              />{' '}
              {props.format === 'AUDIO' ? 'Audio' : t('video')}
            </Button>
          )}
          {progress.eventType === 6 && (
            <Button
              onClick={() => changeViewHandler(2)}
              className={classes.activityBtn}
            >
              <DoneIcon
                className={`${classes.doneIcon} ${
                  (progress.mediaStatus === 2 ||
                    props.quizProgress === 2) &&
                  classes.success
                } ${
                  (progress.mediaStatus === 1 ||
                    props.quizProgress === 1) &&
                  classes.progress
                }`}
              />{' '}
              {t('assessment')}
            </Button>
          )}
          {progress.eventType === 3 && (
            <Button
              onClick={() => changeViewHandler(3)}
              className={classes.activityBtn}
            >
              <DoneIcon
                className={`${classes.doneIcon} ${
                  (progress.mediaStatus === 2 ||
                    props.homeworkProgress === 2) &&
                  classes.success
                } ${progress.mediaStatus === 1 && classes.progress}`}
              />{' '}
              {t('activity')}
            </Button>
          )}
          {progress.eventType === 5 && (
            <Button
              onClick={() => changeViewHandler(4)}
              className={classes.activityBtn}
            >
              <DoneIcon
                className={`${classes.doneIcon} ${
                  props.coevaluationProgress >= 3 && classes.success
                } ${
                  props.coevaluationProgress > 0 && classes.progress
                }`}
              />{' '}
              {t('peer_evaluation')}
              <span className={classes.coevaluationText}>
                ({props.coevaluationProgress} / 3)
              </span>
            </Button>
          )}
        </>
      ))}

      {props.material &&
        (props.material.length > 0 ? (
          <>
            <p className={classes.text}>{t('support_material')}</p>
            <ul className={classes.materialList}>
              {props.material.map(item => (
                <li
                  key={item.idArchivoVideo}
                  className={classes.material}
                >
                  <a
                    className={classes.materialLink}
                    href={item.path}
                    target="_blank"
                    rel="noReferrer"
                  >
                    <LinkIcon className={classes.materiaIcon} />{' '}
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p className={classes.text}>{t('no_support_material')}</p>
        ))}
    </div>
  );
};

Activities.propTypes = {
  // eslint-disable-next-line react/require-default-props
  material: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  lessonData: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  lessonProgress: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  videoProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  quizProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  homeworkProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  coevaluationProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  format: PropTypes.string
};

export default Activities;
